import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const needsTweetButtonDataTypeConversion =
    data.widget &&
    data.widget.type === 'twitter' &&
    (data.widget.mode === undefined || data.widget.mode === 'tweet');

  const needsFollowButtonDataTypeConversion =
    data.widget &&
    data.widget.type === 'twitter' &&
    data.widget.mode &&
    data.widget.mode === 'follow';

  const tweetButtonDefaults = {
    widget: {
      mode: {
        tag: 'tweet',
        val: {
          url: '',
          text: '',
          show_count: {
            tag: 'true',
            val: {__deprecated__count_layout: 'horizontal'},
          },
        },
      },
      size: 'm',
      type: 'twitter',
      html: true,
    },
  };

  const followButtonDefaults = {
    widget: {
      mode: {
        tag: 'follow',
        val: {
          show_count: 'true',
        },
      },
      size: 'm',
      type: 'twitter',
      html: true,
    },
  };

  return {
    needed:
      needsTweetButtonDataTypeConversion || needsFollowButtonDataTypeConversion,
    logData: {
      msg: 'Twitter data should be converted to Data Type',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (needsTweetButtonDataTypeConversion) {
        const updatedData = {...tweetButtonDefaults};

        if (data.widget.url) {
          updatedData.widget.mode.val.url = data.widget.url;
        }

        if (data.widget.text) {
          updatedData.widget.mode.val.text = data.widget.text;
        }

        if (data.widget.count === undefined || data.widget.count === true) {
          updatedData.widget.mode.val.show_count.tag = 'true';

          if (data.widget.countType === 'horizontal') {
            updatedData.widget.mode.val.show_count.val = {
              __deprecated__count_layout: 'horizontal',
            };
          }

          if (data.widget.countType === 'vertical') {
            updatedData.widget.mode.val.show_count.val = {
              __deprecated__count_layout: 'vertical',
            };
          }
        }

        if (data.widget.count === false) {
          updatedData.widget.mode.val.show_count.tag = 'false';
          // @ts-expect-error - TS2540 - Cannot assign to 'val' because it is a read-only property.
          updatedData.widget.mode.val.show_count.val = 'false';
        }

        if (data.widget.large) {
          updatedData.widget.size = 'l';
        }

        data.widget = updatedData.widget;
      }

      if (needsFollowButtonDataTypeConversion) {
        const updatedData = {...followButtonDefaults};

        if (data.widget.user) {
          // @ts-expect-error - TS2339 - Property 'screen_name' does not exist on type '{ readonly show_count: "true"; }'.
          updatedData.widget.mode.val.screen_name = data.widget.user;
        }

        if (data.widget.count === undefined || data.widget.count === true) {
          updatedData.widget.mode.val.show_count = 'true';
        }

        if (data.widget.count === false) {
          updatedData.widget.mode.val.show_count = 'false';
        }

        if (data.widget.large) {
          updatedData.widget.size = 'l';
        }

        data.widget = updatedData.widget;
      }
    },
  };
};
